import React from 'react';
import styled from 'styled-components';
import "@fontsource/ibm-plex-mono";

const ItemWrapper = styled.a`
    height: 100%;
    transition: all 0.3s ease;
    opacity: .8;
    display: flex;
    flex-direction: column;
    text-decoration: none;
    &:hover {
        opacity: 1;
    }

    h3 {
        font-size: 16px;
        color: #a13b16;

    }
`;

const NewsDate = styled.div`
    color: #3b6255;
    font-size: 12px;
    margin: 10px 0;
`;

type CarouselItemProps = {
    title: string;
    image_src: string;
    link: string;
    date: string | never;
};

const CarouselItem: React.FC<CarouselItemProps> = ({ title, image_src, link, date}) => {
    return (
        <ItemWrapper href={link} target="_blank" rel="noopener noreferrer">
                <h3>{title}</h3>
                <NewsDate>
                    {new Date(date).toLocaleDateString('uk-UA', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                    })}
                </NewsDate>
                <img src={image_src} />
        </ItemWrapper>
    );
};

export default CarouselItem;